import styled, { css } from "styled-components/macro";
import { media } from "../../utils";

const getImageStyles = (backgroundImage) =>
  backgroundImage
    ? css({
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center right",
        backgroundSize: "cover",
      })
    : null;
const getImageStylesMobile = (backgroundImageMobile) =>
  backgroundImageMobile
    ? css({
        backgroundImage: `url(${backgroundImageMobile})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      })
    : null;

export const BannerTitle = styled.span(() => ({
  "@media (max-width: 611px)": {
    paddingTop: "200px",
  },
  small: {
    display: "block",
    fontSize: "24px",
    fontWeight: "400",
    marginBottom: "-8px",
    [media.md()]: {
      fontSize: "28px",
    },
  },
}));

export const BannerColumnContent = styled.div(({ reverse }) => ({
  padding: `${0} !important`,
  [media.lg()]: {
    position: reverse ? 1 : 0,
  },
}));

const ContentHeightStyles = (contentHeight) =>
  contentHeight
    ? css({
        height: `${contentHeight}px`,
      })
    : null;

export const CollumnContainer = styled.div(() => ({
  margin: "0 !important",
  padding: "0 !important",
}));

export const BackIcon = styled.svg({
  marginRight: "17.5px",
});

export const BackLink = styled.a({
  textDecoration: "none",
  fontWeight: "500",
  display: "flex",
  alignItems: "center",
  padding: "25.5px",
});

export const Back = styled.div(({ theme }) => ({
  backgroundColor: theme.color.neutral["08"],
  color: theme.color.brandPrimary.light,
  borderTop: `1px solid ${theme.color.line.medium}`,

  [media.lg()]: {
    display: "none",
  },
}));

export const SubPageBreadcrumb = styled.div({
  display: "none",
  paddingBottom: "40px",
  [media.lg()]: {
    display: "flex",
  },
});

const Banner = styled.div`
  box-shadow: none !important;

  ${media.sm()} {
    ${({ backgroundImage }) => getImageStyles(backgroundImage)}
  }
  ${({ backgroundImageMobile }) => getImageStylesMobile(backgroundImageMobile)}
  ${({ contentHeight }) => ContentHeightStyles(contentHeight)} 
  &.bottom-hide {
    margin-bottom: 0 !important;
  }
`;

export default Banner;
